(function () {
  const root = document.querySelector(":root");

  /* Set Width */
  const widthObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const { target } = entry;

      // Get css variable from data attribute
      let cssVar = target.dataset.observeWidth;

      if (!target.classList.contains("js-disable-observe-width")) {
        // Update css variable
        root.style.setProperty(
          cssVar,
          entry.borderBoxSize[0].inlineSize + "px"
        );
      }
    });
  });

  // Set Width - select elements and initialize Observer
  const widthSelector = document.querySelectorAll("[data-observe-width]");

  widthSelector.forEach((item) => {
    widthObserver.observe(item);
  });
  /* / Set Width */

  /* Set Height */
  const heightObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const { target } = entry;

      // Get css variable from data attribute
      let cssVar = target.dataset.observeHeight;

      // Update css variable
      root.style.setProperty(cssVar, entry.borderBoxSize[0].blockSize + "px");
    });
  });

  // Set Height - select elements and initialize Observer
  const heightSelector = document.querySelectorAll("[data-observe-height]");

  heightSelector.forEach((item) => {
    heightObserver.observe(item);
  });
  /* / Set Height */
})();
